<!-- 媒体元素列表项通用组件：包含视频、音频、图片-->
<template>
    <div class="media-item-wrap">
        <div class="cover-img-box" @click="handlePlayVideo">
          <el-image
            :class="isVideoOrAudio() ? 'cover-img' : 'cover-img-ani'"
            style="width:100%;height:100%;"
            :src="coverImg"
            :preview-src-list="previewSrcList"
            fit="cover"
            ></el-image>
          <el-image v-if="isVideoOrAudio()"
            class="play-btn"
            :src="require('@/assets/img/ic-play.png')"
            fit="contain"
            title="播放"
            ></el-image>
        </div>
        <div class="title" v-if="titleShown" :title="title">
            <span>{{title}}</span>
        </div>
    </div>
  </template>

  <script>


    export default {
      components: { },
      props: {
        coverImg: null,
        title: null,
        image: null,
        video: null,
        audio: null,
        titleShown: {
            type: Boolean,
            default: true,
        },
        previewSrcList: null,
        articleId: null,
      },
      data() {
          return {

          };
        },
      methods: {
        handlePlayVideo(){
          if(this.video != null || this.audio != null){ 
            let routeData = this.$router.resolve({
                path: '/player',
                query:{
                  id: this.articleId,
                }
              });
            window.open(routeData.href, '_blank');
          }
        },

        isVideoOrAudio(){
          if(this.video != null || this.audio != null){
            return true;
          }
          return false;
        }
      },
      created() {

      },
      mounted() {}
    };
  </script>

  <style scoped>
    .media-item-wrap{
        padding: 0px;
        cursor: pointer;
        box-sizing: border-box;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .cover-img-box{
      width: 100%;
      height: 100%;
      overflow: hidden;
      flex-grow: 1;
      position: relative;
    }
    .cover-img-ani{
      transition:all 0.35s ease-in-out;
      overflow: hidden;
    }
    .cover-img-ani:hover{
      transform: scale(1.1);
      overflow: hidden;
    }

    .title{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        padding: 15px;
        align-self: stretch;
        background: #FFFFFF;
        box-sizing: border-box;
        flex: 0 0 80px;
        box-sizing: border-box;
    }
    .title span{
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 14px;
    }
    .play-btn{
      width:60px;
      height: 60px;
      cursor: pointer;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .play-btn:hover{
      opacity:0.7;
    }

@media screen and (max-width:680px){
  .title{        
    padding: 10px;        
    flex: 0 0 60px;        
  }
}
@media screen and (min-width: 601px) and (max-width: 800px) {
  .title{
    flex:none;
  }
}
  </style>



// WEBPACK FOOTER //
// src/components/basic/mediaitem/index.vue